import React from "react";
import DatePicker from "react-datepicker";
import moment from "moment";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { setRedirectPath } from "../../modules/actions/authActions";
import { getCart } from "../../modules/actions/cartActions";
import { addToCart } from "../../modules/actions/cartActions";
import { addFlashMessage } from "../../modules/actions/flashMessages.js";
import { Link, withRouter } from "react-router-dom";
import { format } from "../../modules/utils"
import { getESimProducts } from "../../modules/actions/productActions";
//import { getCountries } from "../../modules/actions/countryActions";
import NotificationAlert from "react-notification-alert";
import scrollToElement from "scroll-to-element";
import {confirmAlert} from 'react-confirm-alert';
import MaskedInput from 'react-text-mask'
import "react-datepicker/dist/react-datepicker.css";
import 'react-confirm-alert/src/react-confirm-alert.css';

class PurchaseESimCart extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            useType : "USA",
            cartType : "esim",
            receiveType: "DELIVERY",
            returnType: "Mail",
            shippingFee: 0,
            quantity: 1,
            startDate : moment(),
            product: {},
            orgProduct : {},
            color : null,
            country : null,
            buy_option: null, //android or iphone
            promotion : null,
            imei: null,
            eid: null,
            showingAlert: false
        };
        this.props.getESimProducts();
        /*this.props.getCountries();
        this.countries = [];*/
        // this.setProduct();
    }

    handleClickShowAlert() {
        this.setState({
            showingAlert: true
        });

        setTimeout(() => {
            this.setState({
                showingAlert: false
            });
        }, 2000);
    }

    onStartDateChange = date => {
        this.setState({
            startDate : date
        });
    };

    _getSubTotal = (fraction = 2) => {
        let total = 0;
        let productTotal = this.getPriceByUseType(this.state.product);
        let recurringPrice = 0;
        if (typeof this.state.recurringProfile !== "undefined" && this.state.recurringProfile !== null){
            //recurringPrice = this.getPriceByUseType(this.state.recurringProfile);
            recurringPrice = this.state.recurringProfile.price;
        }
        total = parseFloat(productTotal) + parseFloat(recurringPrice);
        return total.toFixed(fraction);
    };

    getPriceByUseType(object){
        let price = 0;
        let useType = "USA";
        if (typeof this.state.useType !== "undefined"){
            useType = this.state.useType;
        }

        switch (useType) {
            case "USA" :
                price = object.domesticPrice;
                break;

            case "GLOBAL":
                price = object.globalPrice;
                break;

            default:
                price = object.domesticPrice;
        }

        return price;
    }

    calculateDeliveryCharges(receiveType){
        let price = 0;
        return price;
    }

    calculateReturnCharges(returnType){
        let price = 0;
        return price;
    }

    getCalculatedShipping = () => {
        let deliveryCharges = this.calculateDeliveryCharges(this.state.receiveType);
        let returnCharges = this.calculateReturnCharges(this.state.returnType);
        return parseFloat(deliveryCharges) + parseFloat(returnCharges);
    };


    showMessage(message){
        this.refs.notify.notificationAlert({
            place: "bl",
            message: (
                <div>
                    <div>
                        <b>{message}</b>
                    </div>
                </div>
            ),
            type: "danger",
            icon: "now-ui-icons ui-1_bell-53",
            autoDismiss: 7
        });
    };

    addToCart = () => {

        /*if (this.state.buy_option == "buy_device"){
            this.setState({
                useType : "GLOBAL"
            })
        }*/

        const { product, color, country, useType, receiveType, returnType, shippingFee, quantity, cartType, imei, eid, promotion } = this.state;
        const sessionId = localStorage.getItem("sessionId");
        const productId = product._id;
        const subtotal = this._getSubTotal();
        const total = this._getSubTotal();

        /*if (typeof color === "undefined" || color === null) {
            this.setErrorMessage("Please select your color above.");
            return;
        }

        /*
		if (typeof useType === "undefined" || useType === null) {
            this.setErrorMessage("Please select a Plan.");
            return;
        }

        if (useType === "GLOBAL" && (typeof country === "undefined" || country === null)) {
            this.setErrorMessage("Please select a Country.");
            return;
        }		
		*/

        if (typeof this.state.setAssocProductId === "undefined" || this.state.setAssocProductId === null) {
            this.setErrorMessage("Please select Carrier.");
            return;
        }

        if (typeof this.state.recurringProfile === "undefined" || this.state.recurringProfile === null || typeof this.state.associatedProduct === "undefined" || this.state.associatedProduct === null) {
            this.setErrorMessage("Please select a plan");
            return;
        }

		if (typeof this.state.buy_option === "undefined" || this.state.buy_option === null) {
            this.setErrorMessage("Please select a smart phone type");
            return;
        }

		if (typeof this.state.imei === "undefined" || this.state.imei === null) {
            this.setErrorMessage("Please input an IMEI");
            return;
        }

		if (typeof this.state.buy_option !== "undefined" && this.state.buy_option !== null && this.state.buy_option === "android" && (typeof this.state.eid === "undefined" || this.state.eid === null)) {
            this.setErrorMessage("Please input an EID Number");
            return;
        }

        let startDate = "";
        let endDate = "";

        if (typeof this.state.startDate !== "undefined") {
            startDate = format(this.state.startDate);
        }

        if (typeof this.state.startDate !== "undefined" && typeof this.state.endDate !== "undefined") {
            startDate = format(this.state.startDate);
            endDate = this.endDate;
        }

        let recurring_profile_id = null;

        if (typeof this.state.recurringProfile !== "undefined" && this.state.recurringProfile !== null){
            recurring_profile_id = this.state.recurringProfile._id;
        }

        let associated_product_id = null

        if (typeof this.state.associatedProduct !== "undefined" && this.state.associatedProduct !== null){
            associated_product_id = this.state.associatedProduct._id;
        }

        const buy_option = this.state.buy_option;

        let payload = {
            cartType,
            startDate,
            endDate,
            useType,
            receiveType,
            returnType,
            quantity,
            sessionId,
            total,
            subtotal,
            shippingFee,
            productId,
            product,
            color,
            country,
            imei,
            eid,
            promotion,
            recurring_profile : recurring_profile_id,
            associated_product : associated_product_id,
            buy_option : buy_option
        };

        this.performCartAction(payload);
    };

    performCartAction(payload){
        const { auth } = this.props;
        const promotion = this.state.promotion;
        if (auth.isAuthenticated) {
            this.props
                .addToCart(payload)
                .then(data => {
                    if (data.status) {
                        if(promotion) {
                            this.context.router.history.replace({
                                pathname: "/checkout",
                                params: {
                                    product: this.state.product,
                                    cart: payload,
                                    associatedProduct: this.state.associatedProduct,
                                    recurringProfile: this.state.recurringProfile,
                                    //promotion: promotion,
                                    discount: this.getDiscountCode(promotion)
                                }
                            });
                        }
                        else {
                            this.context.router.history.push({
                                pathname: "/checkout",
                                params: {
                                    product: this.state.product,
                                    cart: payload,
                                    associatedProduct: this.state.associatedProduct,
                                    recurringProfile: this.state.recurringProfile
                                }
                            });
                        }
                    } else {
                        this.showMessage(data.message);
                    }
                })
                .catch(error => {
                    console.log(error);
                    this.showMessage(error.response.data.message);
                });
        } else {
            this.props.setRedirectPath("/checkout", payload);
            this.context.router.history.push({
                pathname : "/login",
                params : {
                    product : payload.product,
                    cart : payload,
                    associatedProduct:  this.state.associatedProduct,
                    recurringProfile : this.state.recurringProfile,
                    promotion: promotion,
                    discount: this.getDiscountCode(promotion)
                }
            });
        }
    }

    componentDidMount() {
        if (typeof this.props.location.state !== 'undefined' && typeof this.props.location.state.anchor !== 'undefined') {
            scrollToElement("#" + this.props.location.state.anchor, { offset: 0 });
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if(typeof this.state.country === "undefined" || this.state.country === null || Object.keys(this.state.country).length === 0) {
            console.log("nextProps", nextProps);
            if (typeof nextProps.products !== "undefined" && nextProps.products.length > 0) {
                let product = nextProps.products[0];
                /*this.setState({
                    product: {...product},
                    orgProduct: {...product}
                })*/
                this.state.product = product;
                this.state.orgProduct = product;

                /*const promotion = this.context.router.route.match.params.promotion;
                if (promotion && this.getDiscountCode(promotion) != null) {*/
                if (typeof nextProps.location.state !== "undefined" &&
                    typeof nextProps.location.state.promotion !== "undefined" &&
                    typeof nextProps.location.state.buy_option !== "undefined" &&
                    typeof nextProps.location.state.useType !== "undefined") {

                    const promotion = nextProps.location.state.promotion;
                    if (promotion && this.getDiscountCode(promotion) != null) {
                        this.state.product = product;
                        this.state.orgProduct = product;
                        this.state.promotion = nextProps.location.state.promotion;
                        this.state.buy_option = nextProps.location.state.buy_option;
                        this.state.useType = nextProps.location.state.useType;
                        /*if (typeof nextProps.location.state.color !== "undefined") {
                            this.setColor(nextProps.location.state.color);
                        }*/
                        this.state.setAssocProductId = product.associated_products[1]._id;
                        var recurringProfile = product.associated_products[1].recurring_profiles[3]; //50GB
                        if (promotion == "79") {
                            recurringProfile = product.associated_products[1].recurring_profiles[0]; //3G
                        }
                        else if (promotion == "105") {
                            recurringProfile = product.associated_products[1].recurring_profiles[2]; //20G
                        }
                        this.state.recurringProfile = recurringProfile;
                        this.state.associatedProduct = product.associated_products[1];
                        this.state.country = null;

                        /*
                        if(typeof this.props.cart.cart !== 'undefined' && typeof this.props.cart.cart.product !== 'undefined') {
                            this.props.cart.cart.product.image = "/images/mightywifi-cloud-" + nextProps.location.state.color.toLowerCase() + ".png";
                            this.props.cart.cart.product.color = nextProps.location.state.color;
                            this.props.cart.cart.color = nextProps.location.state.color;
                        }
                        console.log(this.props.cart.cart);
                        */

                        this.addToCart();
                    }
                }
            }

            /*if (typeof nextProps.countries !== "undefined" && nextProps.countries.length > 0) {
                this.countries = nextProps.countries;
            }*/

            if (typeof nextProps.location.state !== "undefined" &&
                typeof nextProps.location.state.useType !== "undefined" &&
                typeof nextProps.location.state.country !== "undefined" &&
                typeof nextProps.location.state.associatedProduct !== "undefined" &&
                typeof nextProps.location.state.recurringProfile !== "undefined") {

                this.state.useType = nextProps.location.state.useType;
                this.state.country = nextProps.location.state.country;
                this.state.setAssocProductId = nextProps.location.state.associatedProduct._id;
                this.state.associatedProduct = nextProps.location.state.associatedProduct;
                if (nextProps.location.state.useType === "GLOBAL") {
                    this.state.product.associated_products = nextProps.location.state.country.associated_products;
                }
                this.state.recurringProfile = nextProps.location.state.recurringProfile;
            }

			if(typeof this.props.product !== 'undefined' && this.props.product !== null && typeof this.props.profile !== 'undefined' && this.props.profile !== null) {
	            this.state.setAssocProductId = this.props.product._id;
                this.state.associatedProduct = this.props.product;
                this.state.recurringProfile = this.props.profile;
            }
			else {
			    // select first product and profile
                if (typeof nextProps.products !== "undefined" && nextProps.products.length > 0) {
                    let product = nextProps.products[0];
                    this.state.setAssocProductId = product.associated_products[0]._id;
                    this.state.associatedProduct = product.associated_products[0];
                    this.state.recurringProfile = product.associated_products[0].recurring_profiles[0];
                }
            }
        }
    }

    setBuyOption(buyOption){
        this.setState({
            buy_option : buyOption
        })
    }

    setErrorMessage(errorMessage){
        this.setState({
            errorMessage: errorMessage
        })
    }

    setUseType(useType){
        if(useType !== this.state.useType) {
            this.setState({
                useType: useType
            })
            this.setState({
                recurringProfile: null,
                associatedProduct: null,
                country: null
            });
            this.state.product.associated_products = this.state.orgProduct.associated_products;
        }
    }

    /*setColor(color) {
        if(color !== this.state.color) {
            this.setState({
                color: color
            })
            //this.state.product.image = "/images/mightywifi-cloud-" + color.toLowerCase() + ".png";
            this.state.product.color = color;
        }
    }*/

    /*getCountryById(id){
        var country = this.countries.find((country) => {
            return id === country._id
        });
        return country;
    }*/

    reset() {
		this.props.setProduct(null);
		this.props.setProfile(null);

        this.setState({
			/*
			setAssocProductId : null,
            associatedProduct : null,
			*/			
			recurringProfile : null,
            
			buy_option : null,
            errorMessage : null,
            color : null,
            useType : "USA",
            startDate : moment(),
            product : this.state.product,
            country : null,
            imei : null,
            eid : null
        })
    }

    _onChange = event => {
        const field = event.target.name;
        const value = event.target.value;

        this.setState({ [field]: value.trim() });

        /*
        if(field == 'country') {
            let useType = null;
            let country = this.getCountryById(value);
            if(country != null && typeof country.type !== "undefined" && country.type != null) {
                useType = country.type;
            }
            if(country != null && typeof country.associated_products !== "undefined" && country.associated_products != null && country.associated_products.length > 0) {
                this.state.product.associated_products = country.associated_products;
            }
            else {
                this.state.product.associated_products = this.state.orgProduct.associated_products;
            }
            this.setState({
                useType: useType,
                country: country,
                setAssocProductId : null,
                recurringProfile : null,
                associatedProduct : null
            });
        }
        */
    }

    setAssociatedProduct(product) {
        if(product._id !== this.state.setAssocProductId) {
            this.setState({
                setAssocProductId: product._id,
                associatedProduct: product,
                recurringProfile : null,
                startDate : moment(),
                buy_option : null,
                imei : null,
                eid : null
            })
        }
    }

    getDiscountCode(promotion) {
        if(promotion == "120") {
            return "Amazon50GB";
        }
        else if(promotion == "105") {
            return "Amazon20GB";
        }
        else if(promotion == "79") {
            return "Amazon3GB";
        }
        else {
            return null;
        }
    }

    onRecurringProfileSelect(associatedProduct,recurringProfile){
        this.setState({
            recurringProfile : recurringProfile,
            associatedProduct : associatedProduct
        });
    }

    render() {
        const { product, associatedProduct, recurringProfile } = this.state;
		//console.log(product, associatedProduct, recurringProfile);
        let p_type = 'att';
        let p_image_url = '/images/mighty-esim-att.png';
        if (this.state.associatedProduct) {
            p_type = this.state.associatedProduct.type;
            p_image_url = this.state.associatedProduct.image;
        }
        let p_country_id = '';
        if (this.state.country) {
            p_country_id = this.state.country._id;
        }

		var imeiMask = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
		var eidMask = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];

        // Checking stock
        /*
        const hasStock = true;
        const hasStock = this.state.color !== null && (this.state.color !== 'BLUE' && this.state.color !== 'BLACK') ? false : true;
        const hasStock = this.state.color !== null && (this.state.color !== 'BLUE') ? false : true;
        */
        //const hasStock = this.state.color !== null && this.state.color !== 'BLACK' ? false : true;
        //const hasStock = false;
        const hasStock = true;

        return(
            <section className="BodyContainer">
                <div className="container">
                    <div className="row position-relative">

                        <NotificationAlert ref="notify"/>

                        <div className="col-md-5 services_img_bg">
                            <div className="col-lg-12">
                                <div className="m-product-title">
                                    MightyWifi <span className="Serif">Buy</span>
                                </div>
                            </div>
                            <div style={{paddingTop: "50px"}}>
                                <img src={p_image_url} alt="Mighty Prepaid Plan" />
                            </div>
                            <div style={{paddingTop: "30px"}}>
                                <p className="mb-0 mt-2">
									<strong>
                                    {
										(typeof recurringProfile !== "undefined" && recurringProfile !== null) ? recurringProfile.description : null
									}
									</strong>                                    
                                </p>
                            </div>
                        </div>

                        <div className="col-md-7 services_clip pt-d-5p">
                            <div className="services_bg_pad">
                                    <div className="row justify-content-center">
                                    <div className="col-lg-12">
                                        <div className="text-left device_boxes mt-3 rounded p-4">
                                            <div id="GlobalPoint" className="services_content mt-3">

                                                {
                                                    (!hasStock) ? (
                                                        <div>
                                                            {/*<div style={{clear:"both",height:"30px"}}></div>*/}
                                                            {/*<strong>Thank you for your interest in Mightywifi, we are currently out of stock. Please revisit us soon.</strong><br/>*/}
                                                            <span style={{color:"#cc0000",fontWeight:"bold"}}>OUT OF STOCK. NEW eSIM AVAILABLE IN JULY.</span><br/>
                                                            <p className="mb-1"><small>Please leave us your contact information at <a href="mailto:support@mightywifi.net">support@mightywifi.net</a>, we will contact you once we have availability again.</small></p>
                                                        </div>
                                                    ) : null
                                                }

                                                {
                                                    (hasStock && typeof product.associated_products !== "undefined" && typeof this.state.useType !== "undefined" && this.state.useType !== null && (this.state.useType !== "GLOBAL" || (typeof this.state.country !== "undefined" && this.state.country !== null))) ? (
                                                        <div>
                                                            <strong>eSIM for&nbsp;
															{
																(typeof associatedProduct !== "undefined" && associatedProduct !== null) ? associatedProduct.name : null
															}
															</strong>
                                                        </div>
                                                    ) : null
                                                }

                                                <div style={{clear:"both",height:"15px"}}></div>
                                                {
                                                    (hasStock && (typeof this.props.product === "undefined" || this.props.product === null) && typeof product.associated_products !== "undefined" && product.associated_products !== null && typeof this.state.useType !== "undefined" && this.state.useType !== null && (this.state.useType !== "GLOBAL" || (typeof this.state.country !== "undefined" && this.state.country !== null))) ?
                                                        product.associated_products.map(
                                                            associated_product => (
                                                                <span>
                                            <a className={`btn btn-white mr-15` + ((this.state.setAssocProductId && this.state.setAssocProductId !== null && this.state.setAssocProductId == associated_product._id) ?  ` active` : "")} onClick={() => this.setAssociatedProduct(associated_product)}>{associated_product.name}{((this.state.useType == "USA" && associated_product.type == "day_pass") ?  ` *` : "")}<br/><span style={{fontSize: "1.0rem",  whiteSpace: "pre-line"}}>{associated_product.shortDescription}</span></a>
                                            </span>
                                                            )
                                                        )
                                                        : null
                                                }

												<div style={{clear:"both",height:"15px"}}></div>
												
												<ul>
													<li>Covers nationwide including New York, Hawaii, etc.</li>
													<li>Local Phone Number, no roaming charge</li>
													<li>Unlimited Data, unlimited SMS</li>
												</ul>                                                

                                                {
                                                    (hasStock && typeof product.associated_products !== "undefined" && product.associated_products !== null && typeof this.state.useType !== "undefined" && this.state.useType !== null && this.state.useType == "USA") ?
                                                        (
                                                            /*<div style={{fontSize:"18px"}}>
                                                                <strong className="uppercase">Day Pass</strong>
                                                                : Day passes offer a more affordable rate and give 1GB per day, refreshing back to 1GB on the next day. This cost-efficient plan is ideal for your single trip where light usage is expected.
                                                                <br/>
                                                                * For a limited time period, UNLIMITED US multiple day passes are available for US travelers.
                                                                <br/>
                                                                <br/>
                                                                <strong className="uppercase">Data Plan</strong>
                                                                : Data plans offer a set amount of data for 30 days starting from the date of activation. Data usage is limited to the data size purchased. This plan is recommended if you want more flexibility in how you use your device.
                                                                <br/>
                                                                <br/>
                                                            </div>*/
                                                            null
                                                        )
                                                        : null

                                                }

                                                {
                                                    (hasStock && typeof product.associated_products !== "undefined" && product.associated_products !== null && typeof this.state.useType !== "undefined" && this.state.useType !== null && this.state.useType == "GLOBAL" && typeof this.state.country !== "undefined" && this.state.country !== null) ?
                                                        (

                                                            /*<div style={{fontSize:"18px"}}>
                                                                <strong className="uppercase">Day Pass</strong>
                                                                : Day passes offer a more affordable rate and give 1GB per day, refreshing back to 1GB on the next day. This cost-efficient plan is ideal for your single trip where light usage is expected.
                                                                <br/>
                                                                <br/>
                                                                <strong className="uppercase">Data Plan</strong>
                                                                : Data plans offer a set amount of data for 30 days or 180 days depending on your data size starting from the date of activation. Data usage is limited to the data size purchased. This plan is recommended if you want more flexibility in how you use your device.
                                                                <br/>
                                                                <br/>
                                                            </div>*/
                                                            null
                                                        )
                                                        : null

                                                }

                                                <div style={{clear:"both",height:"15px"}}></div>

                                                {
                                                    (hasStock && typeof product.associated_products !== "undefined" && typeof this.state.useType !== "undefined" && this.state.useType !== null) ?
                                                        product.associated_products.map(
                                                            associated_product => (

                                                                (this.state.setAssocProductId !== null && associated_product._id == this.state.setAssocProductId) ? (
                                                                    <div className="assoc_product">

                                                                        {/* <strong>{associated_product.name}</strong> */}
                                                                        {/* <div style={{clear:"both",height:"15px"}}></div> */}

                                                                        {
                                                                            (typeof associated_product.recurring_profiles !== "undefined" && associated_product.recurring_profiles.length > 0) ? (
                                                                                associated_product.recurring_profiles.map(
                                                                                    recurring_profile => (
                                                                                        (recurring_profile.status === 1 && recurring_profile.price > 0) ? (
                                                                                            <button onClick={() => this.onRecurringProfileSelect(associated_product,recurring_profile)} className={`btn btn-white mr-15 mb-3 product-btn` + ((this.state.recurringProfile && this.state.recurringProfile !== null && this.state.recurringProfile._id == recurring_profile._id) ?  `btn btn-white mr-15 mb-3 active product-btn` : "")}>{recurring_profile.name} <strong>${recurring_profile.price}</strong></button>
                                                                                        ) : null
                                                                                    )
                                                                                )
                                                                            ) : null
                                                                        }

                                                                        <div style={{clear:"both",height:"15px"}}></div>

                                                                        {
                                                                            ((typeof associated_product.options !== "undefined" && associated_product.options.length > 0) ?  (
                                                                                associated_product.options.map(
                                                                                    option => (

                                                                                        (option.type == "date") ? (
                                                                                            <div className="row">
                                                                                                <div className="col">
                                                                                                    <strong>Start Date</strong>
																									<br/><span style={{
																										color: "#000000",
																										marginTop: "5px",
																										fontSize: "1.0rem"
																									  }}
																									>U.S. Arrival Date</span>
                                                                                                </div>
                                                                                                <div className="col-lg-7">
                                                                                                    <div className="form-group mt-3">
                                                                                                        <DatePicker
                                                                                                            className="form-control data-field"
                                                                                                            selected={this.state.startDate}
                                                                                                            minDate={moment()}
                                                                                                            onChange={this.onStartDateChange}
                                                                                                            id="startDate"
                                                                                                            placeholderText="Start Date"
                                                                                                            onChangeRaw={event => {
                                                                                                                event.preventDefault();
                                                                                                            }}
                                                                                                        />
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        ) : null
                                                                                    )
                                                                                )
                                                                            ) : null)
                                                                        }

                                                                        <div style={{clear:"both",height:"15px"}}></div>
                                                                    </div>
                                                                ) : null
                                                            )
                                                        )
                                                        : null
                                                }

                                                {/*<div style={{clear:"both",height:"15px"}}></div>*/}
                                                {/*<h3 className="SansSerif bold600">${ this.getPriceByUseType(product) }</h3>
                                                <div style={{clear:"both",height:"15px"}}></div>*/}

                                                {/*<div className="ShortDc" style={{whiteSpace:"pre-line"}}>{ product.shortDescription }</div>*/}
                                                {/*<div style={{clear:"both",height:"15px"}}></div>*/}

												{/*<strong>Start Date</strong>
                                                
                                                <div className="form-group mt-3">
													<DatePicker className="form-control data-field"
                                                                selected={this.state.startDate}
                                                                minDate={moment()}
                                                                onChange={this.onStartDateChange}
                                                                id="startDate"
                                                                placeholderText="Start Date"
                                                                onChangeRaw={event => {
																	event.preventDefault();
                                                                }}
                                                    />
                                                </div>

												<div style={{clear:"both",height:"15px"}}></div>*/}

                                                {
                                                    /*(hasStock && typeof this.state.recurringProfile !== "undefined" && this.state.recurringProfile !== null) ? (*/
													hasStock ? (

                                                        <div>
                                                            <div className="form-group mt-3">
																<div className="row">
																	<div className="col">
																		<strong>Smart Phone Type</strong>
																	</div>
																	<div className="col-7">
{
                                                                (hasStock && p_type !== 'att') ? (

                                                            
                                                                <a onClick={ () => this.setBuyOption("android")} className={`btn btn-white mr-15` + ((this.state.buy_option && this.state.buy_option == 'android') ?  ` active` : "")}>
                                                                    Android
                                                                </a>
                                                            

                                                                ) : null
                                                            }

                                                            
																	<a onClick={ () => this.setBuyOption("iphone")} className={`btn btn-white mr-15` + ((this.state.buy_option && this.state.buy_option == 'iphone') ?  ` active` : "")}>
																		iPhone
																	</a>
																
																	</div>
																</div>
                                                            </div>
                                                        </div>

                                                    ) : null
                                                }

                                                {
                                                    /*(hasStock && typeof this.state.buy_option !== "undefined" && this.state.buy_option !== null) ? (*/
													hasStock ? (

                                                        <div>
                                                            <div style={{clear:"both",height:"15px"}}></div>
                                                            <div style={{clear:"both",height:"15px"}}></div>
															<div className="row">
																<div className="col">
																	<strong>IMEI (eSIM)</strong><br/><span style={{
																	color: "#000000",
																	marginTop: "5px",
																	fontSize: "1.0rem"
																  }}
																>(Enter *#06#  to find IMEI)</span>
																</div>
																<div className="col-7">
																	<MaskedInput mask={imeiMask} id="imei-id" className="form-control no-border-radius" name="imei" type="text" value={this.state.imei} onChange={this._onChange} required />
																</div>
															</div>
                                                        </div>

                                                    ) : null
                                                }

                                                {
                                                    /*(hasStock && typeof this.state.buy_option !== "undefined" && this.state.buy_option !== null && this.state.buy_option == "android") ? (*/
													hasStock && (p_type !== 'att' && (this.state.buy_option === null || this.state.buy_option !== "iphone")) ? (

                                                        <div>
                                                            <div style={{clear:"both",height:"15px"}}></div>
															<div className="row">
																<div className="col">
																	<strong>EID Number</strong><br/><span style={{
																	color: "#000000",
																	marginTop: "5px",
																	fontSize: "1.0rem"
																  }}
																>(Android only)</span>
																</div>
																<div className="col-7">
																	<MaskedInput mask={eidMask} id="eid-id" className="form-control no-border-radius " name="eid" type="text" value={this.state.eid} onChange={this._onChange} required />
																</div>
															</div>
                                                        </div>

                                                    ) : null
                                                }

                                                <div id="mask" onClick="document.location='#';"></div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div style={{clear:"both",height:"15px"}}></div>

                        <div className="col-md-12">

                            {
                                (typeof this.state.errorMessage !== "undefined" && this.state.errorMessage !== null) ? (
                                    <span>
                                        <div style={{clear:"both",height:"30px"}}></div>
                                        <span style={{color:"#da0905"}}>{this.state.errorMessage}</span>
                                    </span>
                                ) : null
                            }

                            {
                                /*(hasStock && typeof this.state.buy_option !== "undefined" && this.state.buy_option !== null) ? (*/
								hasStock ? (
                                    <div className="row">
                                        <div className="col-md-12">
                                            {/* <div style={{clear:"both",height:"50px"}}></div> */}
                                            {/* <div className="line"></div> */}
                                            <div style={{clear:"both",height:"40px"}}></div>
                                        </div>
                                        <div className="col-md-8">
                                            <h2 className="mb-0 SansSerif bold100">
                                                YOUR TOTAL IS <span className="bold700">${this._getSubTotal()}</span>
                                            </h2>
                                        </div>
                                        <div className="col-md-4 text-right">
                                            <a className="btn btn-orange mr-15" onClick={this.addToCart}>BUY NOW</a>
                                            <a className="btn btn-white" onClick={() => this.reset()}>RESET</a>
                                        </div>
                                    </div>
                                ) : null
                            }
                            <div style={{ clear: "both", height: "50px" }} />
                        </div>

                        <div className="desktop-view" style={{ clear: "both", height: "150px" }} />
                        <div className="mobile-view" style={{ clear: "both", height: "0px" }} />

                    </div>
                </div>
            </section>

        )
    }
}


PurchaseESimCart.contextTypes = {
    router: PropTypes.object.isRequired
};

function mapStateToProps(state) {
    return {
        auth: state.auth,
        cart: state.cart,
        products: state.product.products,
        countries: state.country.countries
    };
}

export default withRouter(connect(
    mapStateToProps,
    { getESimProducts, addToCart, addFlashMessage, setRedirectPath, getCart }
)(PurchaseESimCart));



// WEBPACK FOOTER //
// ./src/pages/purchaseESim/PurchaseESimCart.js